import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import ReactLink from '@client/components/reactLink/ReactLink';
import styles from './footerSocialIcon.scss';

class FooterSocialIcon extends PureComponent {
  render() {
    const { route, socialName, className } = this.props;

    let classContainer = styles.footerSocialIcon;
    if (className) {
      classContainer += ` ${className}`;
    }
    return (
      <ReactLink className={classContainer} to={route}>
        <div className={styles.socialIconWrapper}>
          <i
            className={`icomoon icon-${socialName}-icon ${styles.socialIcon}`}
          />
        </div>
      </ReactLink>
    );
  }
}

FooterSocialIcon.propTypes = {
  route: PropTypes.string,
  socialName: PropTypes.string,
  className: PropTypes.string,
};

export default withRouter(FooterSocialIcon);
